import React, { useState, createContext, useContext } from 'react';
interface AssessmentData {
  startTime?: number;
  completionTime?: number;
  timestamp?: Date;
  primaryHealing?: string;
  sensitivityLevel?: number;
  healingHistory?: string[];
  appFeatures?: string[];
  investmentLevel?: string;
  communityType?: string;
  emailOptIn?: boolean;
  userEmail?: string;
  userName?: string;
}
interface AssessmentContextType {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  assessmentData: AssessmentData;
  updateAssessmentData: (data: Partial<AssessmentData>) => void;
  resetAssessment: () => void;
}
const defaultAssessmentData: AssessmentData = {};
const AssessmentContext = createContext<AssessmentContextType | undefined>(undefined);
export const AssessmentProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [assessmentData, setAssessmentData] = useState<AssessmentData>(defaultAssessmentData);
  const updateAssessmentData = (data: Partial<AssessmentData>) => {
    setAssessmentData(prevData => ({
      ...prevData,
      ...data
    }));
  };
  const resetAssessment = () => {
    setCurrentStep(0);
    setAssessmentData(defaultAssessmentData);
  };
  return <AssessmentContext.Provider value={{
    currentStep,
    setCurrentStep,
    assessmentData,
    updateAssessmentData,
    resetAssessment
  }} data-id="element-819">
      {children}
    </AssessmentContext.Provider>;
};
export const useAssessment = () => {
  const context = useContext(AssessmentContext);
  if (context === undefined) {
    throw new Error('useAssessment must be used within an AssessmentProvider');
  }
  return context;
};